if (!customElements.get("section-grid")) {
  customElements.define(
    "section-grid",
    class SectionGrid extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector(".section-grid");

        // Desktop configs
        this.enableSliderDesktop = this.getAttribute("data-enable-slider-desktop") === "true";
        this.enableArrowsDesktop = this.getAttribute("data-enable-arrows") === "true";
        this.enableDotsDesktop = this.getAttribute("data-enable-dots") === "true";
        this.columnsDesktop = parseInt(this.getAttribute("data-columns-desktop"));

        // Mobile configs
        this.enableSliderMobile = this.getAttribute("data-enable-slider-mobile") === "true";
        this.enableArrowsMobile = this.getAttribute("data-enable-arrows-mobile") === "true";
        this.enableDotsMobile = this.getAttribute("data-enable-dots-mobile") === "true";
        this.columnsMobile = parseInt(this.getAttribute("data-columns-mobile"));

        // TODO: trocar sliders para usar o glidejs
        // window.addEventListener("load", this.initSlider.bind(this));
      }

      initSlider() {
        if (this.enableSliderDesktop && this.enableSliderMobile) {
          $(this.slider).slick({
            slidesToShow: this.columnsDesktop,
            slidesToScroll: 1,
            dots: this.enableDotsDesktop,
            arrows: this.enableArrowsDesktop,
            infinite: false,
            responsive: [
              {
                breakpoint: 650,
                settings: {
                  slidesToShow: this.columnsMobile,
                  slidesToScroll: this.columnsMobile,
                  dots: this.enableDotsMobile,
                  arrows: this.enableArrowsMobile,
                },
              },
            ],
          });

          const prevArrow = this.querySelector(".slick-prev");
          const slickList = this.querySelector(".slick-list");
          if (prevArrow && slickList) slickList.after(prevArrow);
        } else if (this.enableSliderDesktop || this.enableSliderMobile) {
          // add resize event listener
          window.addEventListener("resize", this.toggleSlider.bind(this));
          this.toggleSlider();
        }
      }

      toggleSlider() {
        // get window width
        const windowWidth = window.innerWidth;

        if (this.enableSliderDesktop && windowWidth > 650) {
          this.initSliderDesktop();
        } else if (this.enableSliderMobile && windowWidth <= 650) {
          this.initSliderMobile();
        } else {
          this.destroySlider();
        }
      }

      initSliderDesktop() {
        $(this.slider).slick({
          slidesToShow: this.columnsDesktop,
          slidesToScroll: 1,
          dots: this.enableDotsDesktop,
          arrows: this.enableArrowsDesktop,
          infinite: false,
        });

        const prevArrow = this.querySelector(".slick-prev");
        const slickList = this.querySelector(".slick-list");
        if (prevArrow && slickList) slickList.after(prevArrow);
      }

      initSliderMobile() {
        $(this.slider).slick({
          slidesToShow: this.columnsMobile,
          slidesToScroll: 1,
          dots: this.enableDotsMobile,
          arrows: this.enableArrowsMobile,
          infinite: false,
        });

        const prevArrow = this.querySelector(".slick-prev");
        const slickList = this.querySelector(".slick-list");
        if (prevArrow && slickList) slickList.after(prevArrow);
      }

      destroySlider() {
        $(this.slider).slick("unslick");
      }
    },
  );
}
